/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Loading_SessionsInputs */

const th_loading_sessions = /** @type {(inputs: Loading_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กำลังโหลดอุปกรณ์ที่เข้าสู่ระบบ…`)
};

const en_loading_sessions = /** @type {(inputs: Loading_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading sessions…`)
};

const ja_loading_sessions = /** @type {(inputs: Loading_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`セッションを読み込んでいます…`)
};

const zh_loading_sessions = /** @type {(inputs: Loading_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在加载课程…`)
};

const es_loading_sessions = /** @type {(inputs: Loading_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando sesiones…`)
};

const pt_loading_sessions = /** @type {(inputs: Loading_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregando sessões…`)
};

const id_loading_sessions = /** @type {(inputs: Loading_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memuat sesi…`)
};

const fr_loading_sessions = /** @type {(inputs: Loading_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chargement des séances…`)
};

const tl_loading_sessions = /** @type {(inputs: Loading_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nilo-load ang mga sesyon…`)
};

const vi_loading_sessions = /** @type {(inputs: Loading_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang tải các buổi…`)
};

const ko_loading_sessions = /** @type {(inputs: Loading_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`세션을 불러오는 중…`)
};

const de_loading_sessions = /** @type {(inputs: Loading_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einheiten werden geladen…`)
};

const ru_loading_sessions = /** @type {(inputs: Loading_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загружаем занятия…`)
};

const tr_loading_sessions = /** @type {(inputs: Loading_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oturumlar yükleniyor…`)
};

const it_loading_sessions = /** @type {(inputs: Loading_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caricamento sessioni…`)
};

const pl_loading_sessions = /** @type {(inputs: Loading_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wczytywanie zajęć…`)
};

const uk_loading_sessions = /** @type {(inputs: Loading_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Завантажуємо заняття…`)
};

const hi_loading_sessions = /** @type {(inputs: Loading_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सत्र लोड हो रहे हैं…`)
};

const ar_loading_sessions = /** @type {(inputs: Loading_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جارٍ تحميل الحصص…`)
};

const ms_loading_sessions = /** @type {(inputs: Loading_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memuat sesi…`)
};

const bn_loading_sessions = /** @type {(inputs: Loading_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সেশন লোড হচ্ছে…`)
};

const zh_tw2_loading_sessions = /** @type {(inputs: Loading_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在載入課程…`)
};

const zh_hk2_loading_sessions = /** @type {(inputs: Loading_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在載入課節…`)
};

const ur_loading_sessions = /** @type {(inputs: Loading_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سیشن لوڈ ہو رہے ہیں…`)
};

const fa_loading_sessions = /** @type {(inputs: Loading_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`در حال بارگذاری جلسات…`)
};

const sw_loading_sessions = /** @type {(inputs: Loading_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inapakia vipindi…`)
};

const nl_loading_sessions = /** @type {(inputs: Loading_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sessies laden…`)
};

/**
* | output |
* | --- |
* | "Loading sessions…" |
*
* @param {Loading_SessionsInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const loading_sessions = /** @type {((inputs?: Loading_SessionsInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Loading_SessionsInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_loading_sessions(inputs)
	if (locale === "ja") return ja_loading_sessions(inputs)
	if (locale === "zh") return zh_loading_sessions(inputs)
	if (locale === "es") return es_loading_sessions(inputs)
	if (locale === "pt") return pt_loading_sessions(inputs)
	if (locale === "id") return id_loading_sessions(inputs)
	if (locale === "fr") return fr_loading_sessions(inputs)
	if (locale === "tl") return tl_loading_sessions(inputs)
	if (locale === "vi") return vi_loading_sessions(inputs)
	if (locale === "ko") return ko_loading_sessions(inputs)
	if (locale === "de") return de_loading_sessions(inputs)
	if (locale === "ru") return ru_loading_sessions(inputs)
	if (locale === "tr") return tr_loading_sessions(inputs)
	if (locale === "it") return it_loading_sessions(inputs)
	if (locale === "pl") return pl_loading_sessions(inputs)
	if (locale === "uk") return uk_loading_sessions(inputs)
	if (locale === "hi") return hi_loading_sessions(inputs)
	if (locale === "ar") return ar_loading_sessions(inputs)
	if (locale === "ms") return ms_loading_sessions(inputs)
	if (locale === "bn") return bn_loading_sessions(inputs)
	if (locale === "zh-TW") return zh_tw2_loading_sessions(inputs)
	if (locale === "zh-HK") return zh_hk2_loading_sessions(inputs)
	if (locale === "ur") return ur_loading_sessions(inputs)
	if (locale === "fa") return fa_loading_sessions(inputs)
	if (locale === "sw") return sw_loading_sessions(inputs)
	if (locale === "nl") return nl_loading_sessions(inputs)
	return en_loading_sessions(inputs)
});